<script setup>
import { computed } from 'vue';
import { EMPRESA_SOCIAL_PLATFORMS } from './socialPlatforms';

const props = defineProps({
  profiles: {
    type: Object,
    default: () => ({}),
  },
});

const links = computed(() =>
  EMPRESA_SOCIAL_PLATFORMS.filter(p => props.profiles?.[p.key]).map(p => ({
    ...p,
    href: `${p.prefix}${props.profiles[p.key]}`,
  }))
);
</script>

<template>
  <div v-if="links.length" class="flex items-center gap-1">
    <a
      v-for="link in links"
      :key="link.key"
      v-tooltip.top="link.label"
      :href="link.href"
      target="_blank"
      rel="noopener noreferrer nofollow"
      class="flex items-center justify-center transition-colors rounded-md size-7 text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12"
    >
      <span :class="link.icon" class="size-4" />
    </a>
  </div>
</template>
